var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-news-article-navigation" }, [
    _c("div", { staticClass: "cp-news-article-navigation-outer-container" }, [
      _c("div", { staticClass: "cp-news-article-navigation-previous" }, [
        _c(
          "a",
          {
            staticClass: "cp-news-article-navigation-container",
            attrs: { href: _vm.prevArticle.url }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("h5", { staticClass: "cp-news-article-navigation-subtitle" }, [
              _vm._v(
                "\n\t\t\t\t\t" + _vm._s(_vm.prevArticle.title) + "\n\t\t\t\t"
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cp-news-article-navigation-next" }, [
        _c(
          "a",
          {
            staticClass: "cp-news-article-navigation-container",
            attrs: { href: _vm.nextArticle.url }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("h5", { staticClass: "cp-news-article-navigation-subtitle" }, [
              _vm._v(
                "\n\t\t\t\t\t" + _vm._s(_vm.nextArticle.title) + "\n\t\t\t\t"
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      { staticClass: "cp-news-article-navigation-title previous" },
      [_c("i", { staticClass: "bi bi-arrow-left" }), _vm._v(" Previous")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "cp-news-article-navigation-title next" }, [
      _vm._v("Next "),
      _c("i", { staticClass: "bi bi-arrow-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }